import React from 'react'
import Component from '../common/Component'
import BenefitsSetBulkEditsComponent from '../BenefitsSet/BenefitsSetBulkEditsComponent'
import { benefitLabels, metadatumFieldsDiffSet } from './medAdvFields'

const defaultFields = {
  default: {
    values: [
      'vericred_id',
      'medicare_plan_id',
      'name',
      'network',
      'plan_ancestor_network',
      'network_reference_codes',
      'issuer_name',
      'plan_type',
      'audience',
      'sbc_name',
      'sbc_url',
      'sob_url',
      'plan_year',
      'service_area_external_key',
      'state_id',
      'plan_ancestor_id',
      'states'
    ],
    pinned: ['vericred_id', 'network', 'medicare_plan_id', 'name']
  }
}

export default class MedicareAdvantageBenefitsSetBulkEditsComponent extends Component {
  render() {
    return (
      <BenefitsSetBulkEditsComponent
        benefitLabels={benefitLabels}
        metadatumFields={metadatumFieldsDiffSet}
        defaultFields={defaultFields}
        benefitsSetUrl="/med_adv_benefits"
        productLine="medicare_advantage"
        includeSbcCheckbox
        sbcCheckboxLabel="Build from Benefit Summaries"
        hideSobUrl
        {...this.props}
      />
    )
  }
}
